var App = App || {};

App.OffcanvasMenu = (function ($) {
    'use strict';

    function Init() {

        const offcanvas = $("#OffcanvasMenu");
        const levels = offcanvas.find(".offcanvas-menu__levels");
        const buttons = offcanvas.find("button[data-offcanvasMenu]");

        buttons.on("click", function () {

            const action = $(this).attr("data-offcanvasmenu");
            const controlsId = $(this).attr("aria-controls");
            const nextItem = $(`#${controlsId}`);

            if (!nextItem.length) return;

            // Update aria-expanded on buttons
            if (action === "fwd") {
                $(this).attr("aria-expanded", "true");
            } else if (action === "back") {
                // find any button with aria-expanded="true" and collapse it
                const expandedButton = buttons.toArray().find(btn => btn.getAttribute('aria-expanded') === "true");
                if (expandedButton) $(expandedButton).attr("aria-expanded", "false");
            }

            // Determine current and next levels
            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels
                .find(`.offcanvas-menu__level[data-level="${currentLevel}"]`)
                .find(".offcanvas-menu__content.active");

            const nextLevel = parseInt(nextItem.parents(".offcanvas-menu__level").attr("data-level"));

            // Update active states
            console.log(currentItem);
            currentItem.removeClass("active");
            nextItem.addClass("active");

            // Update current level data
            levels.attr("data-level", nextLevel);

            // Focus management after CSS animation finishes
            const onTransitionEnd = (event) => {
                // Only run when the property that is actually animating finishes
                if (event.propertyName === 'transform') {
                    const firstFocusable = nextItem.first('a, button');
                    console.log(firstFocusable);
                    (firstFocusable || nextItem).trigger("focus");
                    levels[0].removeEventListener('transitionend', onTransitionEnd);
                }
            };

            // Listen for transitionend on the next item
            levels[0].addEventListener('transitionend', onTransitionEnd);
        });
    }

    return {
        Init: Init
    };

})(jQuery);
